<template>
  <div class="wt-face-on-camera-countdown" :style="colorStyles">
    <div v-if="!lastOne">{{ text }}</div>
    <div v-if="lastOne" class="-lastOne">1</div>
  </div>
</template>

<script>
export default {
  name: 'wtFaceOnCameraCountdown',
  props: {
    seconds: {
      type: Number,
      required: true,
      default: 3,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: 3,
      lastOne: false,
    };
  },
  created() {
    this.text = this.seconds;
  },
  mounted() {
    this.countdownInterval = window.setInterval(() => {
      const newText = this.text - 1;
      if (!newText || newText < 0) {
        window.clearInterval(this.countdownInterval);
      }
      if (newText == 1) {
        this.lastOne = true;
      }
      this.text = newText;
    }, 1000);
  },
  computed: {
    colorStyles() {
      if (this.darkMode) {
        return {
          background: 'rgba(0,0,0,0.5)',
          color: 'rgba(255, 255, 255, 0.8)',
        };
      }
      return {
        background: 'rgba(255, 255, 255, 0.75)',
        color: 'rgba(0, 0, 0, 0.75)',
      };
    },
  },
  destroyed() {
    window.clearInterval(this.countdownInterval);
  },
};
</script>

<style lang="scss" scoped>
.wt-face-on-camera-countdown {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 70px;
  font-weight: 500;
  > div {
    animation: numberShow 1s infinite;
    &.-lastOne {
      animation: lastNumberShow 1s forwards;
    }
  }
  @keyframes numberShow {
    0% {
      opacity: 0.1;
      transform: scale(0.5);
    }
    16% {
      opacity: 1;
      transform: scale(1.25);
    }
    75% {
      opacity: 1;
      transform: scale(1);
    }
    85% {
      opacity: 1;
      transform: scale(1.25);
    }
    100% {
      opacity: 0.1;
      transform: scale(0.5);
    }
  }
  @keyframes lastNumberShow {
    0% {
      opacity: 0.1;
      transform: scale(0.5);
    }
    16% {
      opacity: 1;
      transform: scale(1.25);
    }
    75% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(0);
    }
  }
}
</style>
